import { ApiService } from './../services/api/api.service';
import { ApiInterceptorInterceptor } from './../interceptor/api-interceptor.interceptor';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import CryptoJS from 'crypto-js';

import {
  animate,
  style,
  transition,
  trigger,
  state
} from "@angular/animations";

import { AppSettingsService } from '../services/app-settings/app-settings.service';
import crypto, { x64 } from 'crypto-js';
import { checkDomain } from '../Classes/checkDomain';
import { Session } from 'protractor';
import { SharedService } from '../shared/shared.service';
import { StringOrNumberOrDate } from '@swimlane/ngx-charts';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NavServiceService } from '../services/nav-service.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        padding: '.75rem 1.25rem',
        margin: '0 0 1rem 0'
      })),
      state('out', style({
        opacity: '0',
        height: '0px',
        width: '0px'
      })),
      transition('in <=> out', animate('0.1s'))
    ])
  ]
})

export class LoginComponent implements OnInit {
  @Input() abc: string
  getTopconerUSername: string;
  hidePass = true;
  userIdInput: string;
  passwordInput: string;
  errorMsg:string;
  loading: boolean = false;
  sharedEmail: string;
  userNameSuggestions: string[] = [];
  currentYear:any;
  os:any="windows";
  currentRoute: string = '';
  private unsubscribe : Subject<any> = new Subject<any>();
  roleCode: any = null;
  env = environment;
  constructor(public router: Router, private apiService: ApiService, private appSettingsService: AppSettingsService, private activatedroute: ActivatedRoute, private shared: SharedService, 
    private navService: NavServiceService
  ) 
  {
    // const currentDate = new Date();
    // this.currentYear = currentDate.getFullYear();
  }

  errorDisplay: string;

  ngOnInit(): void {
    this.errorDisplay = 'out';
  }

  login(): any {
    // console.log('1');
    
    if (!this.loading) {
      this.loading = true;
      
      this.apiService.Login(this.userIdInput, this.passwordInput,this.os).subscribe(async (data) => {
        // console.log('data', data);
        
        this.errorMsg = data.message
        this.setErrTextDisplay('out');
        this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe((event) => {
          if (event instanceof NavigationEnd) {
            this.currentRoute = event.urlAfterRedirects; // Store the current route
            localStorage.setItem('currentRoute', this.currentRoute);
            // console.log('Current Route:', this.currentRoute); // For debugging purposes
          }
        });
        

        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        localStorage.setItem('domain', checkDomain().toString());

        const encryptedUserData = CryptoJS.AES.encrypt(JSON.stringify(data.permissions), 'QubeAppsPro').toString();
        localStorage.setItem('user', encryptedUserData);
        if (data.roles.length != 0){
          this.roleCode = data.roles[0];
        }
        
        await this.appSettingsService.loadDefaultCurrency();
        
        ApiInterceptorInterceptor.token = data.access_token;
        ApiInterceptorInterceptor.refresh_token = data.refresh_token;
        this.CallUsername();
      },
      (error) => {
        console.log('3');
        console.log('error', error);
        if(error?.error?.message){
          this.errorMsg = error.error.message;
          this.setErrTextDisplay('in');
          this.loading = false;
        }else{
          this.errorMsg = error.message
          this.setErrTextDisplay('in');
          this.loading = false;
        }
      });
    }
  }

  CallUsername() {
    this.apiService.getbyemailsMY(this.userIdInput).subscribe((data) => {
      let tempUserPerm = localStorage.getItem('user');
      const decryptedBytes = CryptoJS.AES.decrypt(tempUserPerm, 'QubeAppsPro');
      const decryptedUserData = decryptedBytes.toString(CryptoJS.enc.Utf8);

      let userData: any[] = JSON.parse(decryptedUserData);
      if (Number(data?.data?.is_owner) == 1){
        userData.push('access housekeeping');
        const encryptedUserData = CryptoJS.AES.encrypt(JSON.stringify(userData), 'QubeAppsPro').toString();
        localStorage.setItem('user', encryptedUserData);
      }

      localStorage.setItem("userName", data?.data?.name);
      localStorage.setItem("userID", data?.data?.id);
      localStorage.setItem("sideNav", JSON.stringify(true));

      this.sharedEmail = data?.data?.email;
      localStorage.setItem('Email', this.sharedEmail);

      this.setRoleID();
      this.loading = false;
      
      this.navService.navigateToLandPage();
    },
      (error) => {
        this.setErrTextDisplay('in');
        this.loading = false;
      });
  }

  setRoleID(){
    // console.log(this.roleCode);
    if (this.roleCode == null){
      return;
    }

    this.apiService.GetRoleList("portal").subscribe(res => {
      if (res?.success){
        let allData = res?.data?.data;

        if (allData.length != 0){
          allData = allData.filter((x: any) => x.name == this.roleCode);

          // console.log(allData);
          if (allData.length != 0){
            const encryptedRoleID = CryptoJS.AES.encrypt(JSON.stringify(allData[0].id), 'QubeAppsPro').toString();
            localStorage.setItem("role", encryptedRoleID);
          }
        }
      }
    })
  }


  setErrTextDisplay(display: string): void {
    this.errorDisplay = display;
  }

  genRand(num: number) {
    return [...Array(num)].map(() => Math.random().toString(36)[2]).join('');
  }
  base64Url(string: any) {
    return string
      .toString(crypto.enc.Base64)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }
  
  toggleRevealPassword(){
    if (this.loading) {return}
    this.hidePass = !this.hidePass;
  }
    

}


